export const GET_SHIP_OPTION_LIST_SUCCESS = 'GET_SHIP_OPTION_LIST_SUCCESS';
export const SET_SHIP_OPTION_DATA_LOADING = 'SET_SHIP_OPTION_DATA_LOADING';
export const SET_SHIP_OPTIONS_NOT_LOADED = 'SET_SHIP_OPTIONS_NOT_LOADED';
